import { useIntl } from 'react-intl';
import ButtonDropdown from '@rio-cloud/rio-uikit/ButtonDropdown';

import { AppointmentActionKey } from '@/features/maintenance-data/appointmentMessages';
import { ActionKey, resolveActionKeys } from '@/features/maintenance-data/components/maintenanceDataActionsState';
import { RowSelectionDerived } from '@/features/maintenance-data/hooks/useRowSelection';

const ACTIONS_MSG = 'intl-msg:vehicle-diagnostics.maintenance.table.actions';

const LABEL_KEY: Record<ActionKey, string> = {
    markSolved: `${ACTIONS_MSG}.markSolved`,
    revertSolved: `${ACTIONS_MSG}.revertSolved`,
    schedule: `${ACTIONS_MSG}.schedule`,
    editAppointment: `${ACTIONS_MSG}.editAppointment`,
    cancelAppointment: `${ACTIONS_MSG}.cancelAppointment`,
};

export interface MaintenanceDataActionsProps {
    selection: RowSelectionDerived;
    /** WFE `availableActions` gate (MANSC-27552). When omitted, all appointment actions are allowed. */
    availableActions?: ReadonlySet<AppointmentActionKey>;
    /** Disables the dropdown while a mark-solved/revert batch is in flight. */
    isUpdating?: boolean;
    onMarkSolved?: () => void;
    onRevertSolved?: () => void;
    onSchedule?: () => void;
    onEditAppointment?: () => void;
    onCancelAppointment?: () => void;
}

export const MaintenanceDataActions = ({
    selection,
    availableActions,
    isUpdating = false,
    onMarkSolved,
    onRevertSolved,
    onSchedule,
    onEditAppointment,
    onCancelAppointment,
}: MaintenanceDataActionsProps) => {
    const intl = useIntl();

    const handlers: Record<ActionKey, (() => void) | undefined> = {
        markSolved: onMarkSolved,
        revertSolved: onRevertSolved,
        schedule: onSchedule,
        editAppointment: onEditAppointment,
        cancelAppointment: onCancelAppointment,
    };

    const actionKeys = resolveActionKeys(selection, availableActions);
    const items = actionKeys.map((key) => ({
        value: intl.formatMessage({ id: LABEL_KEY[key] }),
        onSelect: () => handlers[key]?.(),
    }));

    return (
        <ButtonDropdown
            title={intl.formatMessage({ id: `${ACTIONS_MSG}.title` })}
            items={items}
            disabled={items.length === 0 || isUpdating}
        />
    );
};
